import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = (page_number, finalFilter) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/reports/chequeReview?page=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
